module.exports = __webpack_public_path__ + "img/cover_mockup.441f64d6.jpg";